import { render, staticRenderFns } from "./SysAdmin.vue?vue&type=template&id=2243f7e6&scoped=true"
import script from "./SysAdmin.vue?vue&type=script&lang=js"
export * from "./SysAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243f7e6",
  null
  
)

export default component.exports